import React from 'react';
import type {
  FmMapSnapshotMetaProps,
  FmMapStageActionsProps,
} from './FmMapStage.types';

/** Glass action row (left/right chrome + title/subtitle context) over the stage. */
export const FmMapStageActions: React.FC<FmMapStageActionsProps> = ({
  leftChrome,
  rightChrome,
  title,
  subtitle,
  subtitleTestId,
  actionsTestId,
  leftChromeTestId,
  rightChromeTestId,
}) => {
  if (!leftChrome && !rightChrome && !title && !subtitle) return null;
  return (
    <div className="fm-map-stage__actions" data-testid={actionsTestId}>
      <div className="fm-map-stage__left" data-testid={leftChromeTestId}>
        {leftChrome}
      </div>
      {(title || subtitle) && (
        <div className="fm-map-stage__context">
          {title ? <div className="fm-map-stage__title">{title}</div> : null}
          {subtitle ? (
            <div className="fm-map-stage__subtitle" data-testid={subtitleTestId}>
              {subtitle}
            </div>
          ) : null}
        </div>
      )}
      <div className="fm-map-stage__right" data-testid={rightChromeTestId}>
        {rightChrome}
      </div>
    </div>
  );
};

export const FmMapSnapshotMeta: React.FC<FmMapSnapshotMetaProps> = ({
  caption,
  description,
  controls,
  legend,
  timeline,
}) => {
  if (!caption && !description && !controls && !legend && !timeline) return null;
  return (
    <figcaption className="fm-map-snapshot__meta">
      {caption || description ? (
        <div className="fm-map-snapshot__text">
          {caption ? <span className="fm-map-snapshot__caption">{caption}</span> : null}
          {description ? (
            <span className="fm-map-snapshot__description">{description}</span>
          ) : null}
        </div>
      ) : null}
      {controls ? <div className="fm-map-snapshot__controls">{controls}</div> : null}
      {legend ? <div className="fm-map-snapshot__legend">{legend}</div> : null}
      {timeline ? <div className="fm-map-snapshot__timeline">{timeline}</div> : null}
    </figcaption>
  );
};
